import DumbbellWebSvg from '@assets/images/svg/dumbbell-web.svg';
import React from 'react';
import { View } from 'react-native';

export interface DumbbellWebIconProps {
    size?: number;
    color?: string;
}

/**
 * Web-safe variant of DumbbellIcon.
 * dumbbell.svg wraps its artwork in a redundant clipPath; SVGR compiles
 * every clipPath to the same DOM id ("prefix__a"), so on web the clip can
 * resolve to a smaller rect from another icon and crop the artwork.
 * dumbbell-web.svg has identical paths without the clip wrapper.
 */
export function DumbbellWebIcon({ size = 24, color = '#4D4D4D' }: Readonly<DumbbellWebIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <DumbbellWebSvg width={size} height={size} color={color} />
        </View>
    );
}

export default DumbbellWebIcon;
